export enum SortOrder {
  DESC = 'desc',
  ASC = 'asc',
}
